import { WbButton } from '@workbench/react';

function VimdtButton({
	label,
	filledIn = true,
	onClick,
	loading = false,
	disabled = false,
	style,
	id,
	className,
	type = 'button',
}) {
	return (
		<WbButton
			id={id}
			className={className}
			style={style}
			variant={filledIn ? 'primary' : 'secondary'}
			size="s"
			type={type}
			loading={loading || undefined}
			disabled={disabled || undefined}
			onClick={() => onClick && onClick()}
		>
			{label}
		</WbButton>
	);
}

export default VimdtButton;
